// ------------------------------------
// Actions
// ------------------------------------

import {
  CognitoUserPool,
  AuthenticationDetails,
  CognitoUser,
  CognitoUserAttribute
} from 'amazon-cognito-identity-js'

import config from '../../../config/cognito'

export function signup (email2, password) {
  const userPool = new CognitoUserPool({
    UserPoolId: config.cognito.USER_POOL_ID,
    ClientId: config.cognito.APP_CLIENT_ID
  })

  var attributeList = []

  var dataEmail = {
    Name : 'email',
    Value : 'email@mydomain.com'
  }
  var attributeEmail = new CognitoUserAttribute(dataEmail)
  attributeList.push(attributeEmail)

  userPool.signUp('msjahn8017', password, attributeList, null, (err, result) => {
    if (err) {
      console.log('error')
      console.dir(err)
      return
    }

    console.dir(result)
  })
}

export const actions = {
  signup
}

const initialState = { authenticated: false }
export default function signupReducer (state = initialState, action) {
  switch (action.type) {
    case 'SIGNUP':
      return { isLoading: true, hasLoaded: false, error: null, authenticated: false }
    case 'SIGNUP_SUCCESS':
      return { isLoading: false, hasLoaded: true, error: null, authenticated: action.payload }
    case 'SIGNUP_FAIL':
      return { isLoading: false, hasLoaded: true, events: [], error: action.payload }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/Signup/modules/signup.js